import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../../../core/_base/crud';
import { AffiliationRelation } from '../models';

export enum AffiliationRelationActionTypes {
  ToggleAffiliationRelationPageLoading = '[AffiliationRelation] Toggle AffiliationRelation Page Loading',
  ToggleAffiliationRelationActionLoading = '[AffiliationRelation] Toggle AffiliationRelation Action Loading',
  RequestAffiliationRelationPage = '[AffiliationRelation] Request AffiliationRelation Page',
  LoadAffiliationRelationPage = '[AffiliationRelation] Load AffiliationRelation Page',
  CancelAffiliationRelationPage = '[AffiliationRelation] Cancel AffiliationRelation Page',
  CreateAffiliationRelation = '[AffiliationRelation] Create AffiliationRelation',
  CreateAffiliationRelationOnServer = '[AffiliationRelation] Create AffiliationRelation On Server',
  UpdateAffiliationRelation = '[AffiliationRelation] Update AffiliationRelation',
  UpdateAffiliationRelationOnServer = '[AffiliationRelation] Update AffiliationRelation On Server',
  DeleteAffiliationRelation = '[AffiliationRelation] Delete AffiliationRelation',
  DeleteAffiliationRelationOnServer = '[AffiliationRelation] Delete AffiliationRelation On Server',
  ThrowAffiliationRelationError = '[AffiliationRelation] Throw AffiliationRelation Error',
  ClearAffiliationRelationError = '[AffiliationRelation] Clear AffiliationRelation Error',
}

export class ToggleAffiliationRelationPageLoading implements Action {
  readonly type = AffiliationRelationActionTypes.ToggleAffiliationRelationPageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleAffiliationRelationActionLoading implements Action {
  readonly type = AffiliationRelationActionTypes.ToggleAffiliationRelationActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestAffiliationRelationPage implements Action {
  readonly type = AffiliationRelationActionTypes.RequestAffiliationRelationPage;

  constructor(
    public payload: {
      entityId: number;
      entityType: 'CONTACT' | 'AFFILIATION_GROUP';
      query: QueryParamsModel;
    },
  ) {}
}

export class LoadAffiliationRelationPage implements Action {
  readonly type = AffiliationRelationActionTypes.LoadAffiliationRelationPage;

  constructor(
    public payload: {
      affiliationRelations: AffiliationRelation[];
      totalCount: number;
      query: QueryParamsModel;
    },
  ) {}
}

export class CancelAffiliationRelationPage implements Action {
  readonly type = AffiliationRelationActionTypes.CancelAffiliationRelationPage;
}

export class CreateAffiliationRelation implements Action {
  readonly type = AffiliationRelationActionTypes.CreateAffiliationRelation;

  constructor(public payload: { affiliationRelation: AffiliationRelation }) {}
}

export class CreateAffiliationRelationOnServer implements Action {
  readonly type = AffiliationRelationActionTypes.CreateAffiliationRelationOnServer;

  constructor(public payload: { affiliationRelation: AffiliationRelation }) {}
}

export class UpdateAffiliationRelation implements Action {
  readonly type = AffiliationRelationActionTypes.UpdateAffiliationRelation;

  constructor(public payload: { affiliationRelation: Update<AffiliationRelation> }) {}
}

export class UpdateAffiliationRelationOnServer implements Action {
  readonly type = AffiliationRelationActionTypes.UpdateAffiliationRelationOnServer;

  constructor(public payload: { affiliationRelation: AffiliationRelation }) {}
}

export class DeleteAffiliationRelation implements Action {
  readonly type = AffiliationRelationActionTypes.DeleteAffiliationRelation;

  constructor(public payload: { id: number }) {}
}

export class DeleteAffiliationRelationOnServer implements Action {
  readonly type = AffiliationRelationActionTypes.DeleteAffiliationRelationOnServer;

  constructor(public payload: { id: number }) {}
}

export class ThrowAffiliationRelationError implements Action {
  readonly type = AffiliationRelationActionTypes.ThrowAffiliationRelationError;

  constructor(public payload: { error: any }) {}
}

export class ClearAffiliationRelationError implements Action {
  readonly type = AffiliationRelationActionTypes.ClearAffiliationRelationError;
}

export type AffiliationRelationActions =
  | ToggleAffiliationRelationPageLoading
  | ToggleAffiliationRelationActionLoading
  | RequestAffiliationRelationPage
  | LoadAffiliationRelationPage
  | CancelAffiliationRelationPage
  | CreateAffiliationRelation
  | CreateAffiliationRelationOnServer
  | UpdateAffiliationRelation
  | UpdateAffiliationRelationOnServer
  | DeleteAffiliationRelation
  | DeleteAffiliationRelationOnServer
  | ThrowAffiliationRelationError
  | ClearAffiliationRelationError;
